export default {
    TYPES: [
        [381, 'OEM'],
        [382, 'Distributor'],
        [383, 'Rep Group'],
    ]
}